import axios from "axios";
import env from "../../constants/apiConst";

export const __ASubheading = async (token, body, page) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${env.ASUBHEADINS_GET}?page=${page || 1}`, options);
  return res;
};

export const __SelectAcuerdosSub = async (token) => {
  const options = {
    method: "GET",
    headers: { Authorization: token ? `Bearer ${token}` : "" }
  };
  const res = await axios(`${env.ASUBHEADINS_ALL}`, options);
  return res;
};

export const __Acuerdos = async (token) => {
  const options = {
    method: "GET",
    headers: { Authorization: token ? `Bearer ${token}` : "" }
  };
  const res = await axios(`${env.TRADEAGRAMENT_ALL}`, options);
  return res;
};

export const __Subpartida = async (token) => {
  const options = {
    method: "GET",
    headers: { Authorization: token ? `Bearer ${token}` : "" }
  };
  const res = await axios(`${env.ASUBHEADINS_ALL}`, options);
  return res;
};
